export const POSITIONS = [
  "(M) Baseball - Pitcher (P)",
  "(M) Baseball - Catcher (C)",
  "(M) Baseball - First Baseman (1B)",
  "(M) Baseball - Second Baseman (2B)",
  "(M) Baseball - Third Baseman (3B)",
  "(M) Baseball - Shortstop (SS)",
  "(M) Baseball - Left Fielder (LF)",
  "(M) Baseball - Center Fielder (CF)",
  "(M) Baseball - Right Fielder (RF)",
  "(M) Basketball - Point Guard (PG)",
  "(M) Basketball - Shooting Guard (SG)",
  "(M) Basketball - Small Forward (SF)",
  "(M) Basketball - Power Forward (PF)",
  "(M) Basketball - Center (C)",
  "(W) Basketball - Point Guard (PG)",
  "(W) Basketball - Shooting Guard (SG)",
  "(W) Basketball - Small Forward (SF)",
  "(W) Basketball - Power Forward (PF)",
  "(W) Basketball - Center (C)",
  "(W) Beach Volleyball - Defender",
  "(W) Beach Volleyball - Blocker",
  "(M) Cross Country - Runner",
  "(W) Cross Country - Runner",
  "(M) Golf - Player",
  "(W) Rowing - Coxswain (Cox)",
  "(W) Rowing - Stroke Seat",
  "(W) Rowing - Bow Seat",
  "(W) Rowing - Rower",
  "(M) Rugby - Prop (Loosehead)",
  "(M) Rugby - Prop (Tighthead)",
  "(M) Rugby - Hooker",
  "(M) Rugby - Lock",
  "(M) Rugby - Flanker (Blindside)",
  "(M) Rugby - Flanker (Openside)",
  "(M) Rugby - Number 8",
  "(M) Rugby - Scrum-half",
  "(M) Rugby - Fly-half",
  "(M) Rugby - Center (Inside)",
  "(M) Rugby - Center (Outside)",
  "(M) Rugby - Winger",
  "(M) Rugby - Full-back",
  "(M) Soccer - Goalkeeper (GK)",
  "(M) Soccer - Defender Center-back (CB)",
  "(M) Soccer - Defender Full-back (Left)",
  "(M) Soccer - Defender Full-back (Right)",
  "(M) Soccer - Defender Wing-back",
  "(M) Soccer - Central Midfielder (CM)",
  "(M) Soccer - Defensive Midfielder (CDM)",
  "(M) Soccer - Attacking Midfielder (CAM)",
  "(M) Soccer - Wide Midfielders (Left)",
  "(M) Soccer - Wide Midfielders (Right)",
  "(M) Soccer - Forward Striker (ST)",
  "(M) Soccer - Forward Winger (Left)",
  "(M) Soccer - Forward Winger (Right)",
  "(W) Soccer - Goalkeeper (GK)",
  "(W) Soccer - Defender Center-back (CB)",
  "(W) Soccer - Defender Full-back (Left)",
  "(W) Soccer - Defender Full-back (Right)",
  "(W) Soccer - Defender Wing-back",
  "(W) Soccer - Central Midfielder (CM)",
  "(W) Soccer - Defensive Midfielder (CDM)",
  "(W) Soccer - Attacking Midfielder (CAM)",
  "(W) Soccer - Wide Midfielders (Left)",
  "(W) Soccer - Wide Midfielders (Right)",
  "(W) Soccer - Forward Striker (ST)",
  "(W) Soccer - Forward Winger (Left)",
  "(W) Soccer - Forward Winger (Right)",
  "(W) Softball - Pitcher (P)",
  "(W) Softball - Catcher (C)",
  "(W) Softball - First Baseman (1B)",
  "(W) Softball - Second Baseman (2B)",
  "(W) Softball - Third Baseman (3B)",
  "(W) Softball - Shortstop (SS)",
  "(W) Softball - Outfielder (Left Fielder)",
  "(W) Softball - Outfielder (Center Fielder)",
  "(W) Softball - Outfielder (Right Fielder)",
  "(M) Tennis - Single Player",
  "(M) Tennis - Double Player",
  "(W) Tennis - Single Player",
  "(W) Tennis - Double Player",
  "(M) Track and Field - Sprinter",
  "(M) Track and Field - Middle-distance Runner",
  "(M) Track and Field - Long-distance Runner",
  "(M) Track and Field - Hurdler",
  "(M) Track and Field - Relay Runner",
  "(M) Track and Field - Thrower",
  "(M) Track and Field - Jumper",
  "(M) Track and Field - Decathlete",
  "(W) Track and Field - Sprinter",
  "(W) Track and Field - Middle-distance Runner",
  "(W) Track and Field - Long-distance Runner",
  "(W) Track and Field - Hurdler",
  "(W) Track and Field - Relay Runner",
  "(W) Track and Field - Thrower",
  "(W) Track and Field - Jumper",
  "(W) Track and Field - Heptathlete",
  "(W) Volleyball - Outside Hitter (OH)",
  "(W) Volleyball - Opposite H",
];
